import update from "immutability-helper";
import {CompanyActions} from "../actions/Company";

export const initialState = () => {
  return {
    eventId: null,
    companyId: null,
    data: {},
    users: [],
    loaded: false,
    errors: null,
    settings: {},
    contents: [],
    accountDialogOpen: false,
    loginDialogOpen: false,
    loginErrors: {}, //  phone: 'Invalid phone number'
    questions: {},
    eventUrl: null,
    startChat: false,
  }
}

const company = (state = initialState(), action) => {
  switch (action.type) {
    case CompanyActions.SET_ATTRIBUTE:
      return update(state, { [action.key]: { $set: action.value } });
    case CompanyActions.RESET_STATE:
      return update(state, {$set: initialState() })
    default:
      return state;
  }
};

export default company;
